/** KAN-877 — non-consuming look: is a Stripe `?checkout=done` return still in the URL (not yet taken by useCheckoutReturn)? */
export function peekCheckoutDone() {
  if (typeof window === 'undefined') return false;
  try { return new URL(window.location.href).searchParams.get('checkout') === 'done'; } catch { return false; }
}
